import { useCallback, useContext, useMemo } from 'react';
import { ToshibaContext } from '../contexts/toshiba.context';
import dayjs from 'dayjs';
import { useSessionStorageState } from 'ahooks';

export const useSnapshot = () => {
  const { snapshot } = useContext(ToshibaContext);

  const allSnapshots = useMemo(() => snapshot?.versions || [], [snapshot]);

  const prefSnapshot = useMemo(() => {
    const curIndex = allSnapshots.findIndex((version) => version.snapshot === snapshot.currentSnapshot);
    if (curIndex === allSnapshots.length - 1) {
      return snapshot?.currentSnapshot;
    }
    return allSnapshots[curIndex + 1].snapshot;
  }, [snapshot, allSnapshots]);

  const getMonthLabel = useCallback(
    (snapshot) => {
      if (!snapshot) {
        return '';
      }
      const month = dayjs(snapshot).month();
      return `${month + 1}月`;
    },
    [snapshot, allSnapshots]
  );

  const snapshotLabel = useMemo(() => {
    if (!snapshot) {
      return {
        actualLabel: '',
        forecastLabel: '',
      };
    }
    const currentSnapshot = snapshot.currentSnapshot;
    const curMonth = dayjs(currentSnapshot).month();
    let actualLabel = '';
    let forecastLabel = '';
    if (curMonth === 3) {
      actualLabel = `4月実績`;
      forecastLabel = `4-3月見込`;
    } else {
      // actualLabel = `4-${month}月実績`;
      actualLabel = `実績(4-${curMonth}月)`;
      // forecastLabel = `${month + 1}-3月見込`;
      forecastLabel = `見込(${curMonth + 1}-3月)`;
    }
    return {
      actualLabel,
      forecastLabel,
    };
  }, [snapshot, allSnapshots]);

  return {
    currentSnapshot: snapshot?.currentSnapshot,
    prefSnapshot,
    allSnapshots,
    targetSnapshotOptions: snapshot
      ? allSnapshots.reduce((versions, version) => {
          if (dayjs(version.snapshot).isBefore(dayjs(snapshot.currentSnapshot))) {
            versions.push({ key: version.snapshot, label: version.snapshot, value: version.snapshot });
          }
          if (version.snapshot === snapshot.versions.at(-1).snapshot && versions.length === 0) {
            versions.push({ key: version.snapshot, label: version.snapshot, value: version.snapshot });
          }
          return versions;
        }, [])
      : [],
    snapshotLabel,
    getMonthLabel,
  };
};
